import React from "react";
import { Calculator, Eye, Trash2 } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the field grid. Edit calculation (computed fields) and Delete are Super Admin only (`canManage`).
export default function FieldRowActions({ row, canManage, onView, onEditComputed, onDelete }) {
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} />
      {canManage && row.compute && <IconAction label="Edit calculation" icon={Calculator} tone="primary" onClick={() => onEditComputed(row)} />}
      {canManage && <IconAction label="Delete" icon={Trash2} tone="danger" onClick={() => onDelete(row)} />}
    </div>
  );
}
